import { IonButton, IonInput, IonLabel } from "@ionic/react";
import React, { useState, useRef } from "react";
import { useRecoilState } from "recoil";
import {
  loggedInUserState,
  networkConnectionStatus,
  PatientState,
} from "../../data/atoms";
import { ActionType, MailType } from "../../models/Enums";
import { localDateTime } from "../../utils/sharedFunction";
import { useForm } from "react-hook-form";
import { UpdatePasswordFromProfile } from "../../services/AuthServices";

interface Props {
  setShowModal: Function;
}

const ResetPasswordModal: React.FC<Props> = ({ setShowModal }) => {
  const modal = useRef<HTMLIonModalElement>(null);
  const [patient, setpatientDetails] = useRecoilState(PatientState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  const [shownCurrentPassword, setShownCurrentPassword] = useState(false);
  const [shownNewPassword, setShownNewPassword] = useState(false);
  const [shownConfirmPassword, setShownConfirmPassword] = useState(false);
  const [isDisabledBtn1, setIsDisabledBtn1] = useState(true);
  const [isDisabledBtn2, setIsDisabledBtn2] = useState(true);
  const [actionType1, setactionType1] = useState<ActionType>(0);
  const [cancelModal, setShowModal1] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );

  const {
    register,
    setError,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      currentPassword: "",
      password: "",
      newPassword: "",
    },
  });
  const showHidePassword = (value: string) => {
    debugger;
    if (value === "currentPassword") {
      setShownCurrentPassword(
        shownCurrentPassword ? !shownCurrentPassword : true
      );
    } else if (value === "newPassword") {
      setShownNewPassword(shownNewPassword ? !shownNewPassword : true);
    } else if (value === "confirmPassword") {
      setShownConfirmPassword(
        shownConfirmPassword ? !shownConfirmPassword : true
      );
    }
  };
  const updateUserPassword = async (
    Password: string,
    CurrentPassword: string
  ) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      let businessType = localStorage.getItem("BusinessType");
      await UpdatePasswordFromProfile({
        Email: localStorage.getItem("resetEmail"),
        UserName: localStorage.getItem("Username"),
        MailType: MailType.PasswordChangedSuccessfullEmail,
        LoggedInUserID: localStorage.getItem("UserID"),
        encryptedServerId: userToEdit.encryptedServerId
          ? userToEdit.encryptedServerId
          : localStorage.getItem("EncryptedServerId"),
        Password: Password,
        CurrentPassword: CurrentPassword,
        WorkstationId: localStorage.getItem("WorkstationId"),
        LocationId: localStorage.getItem("LocationId"),
        BusinessType: businessType ? +businessType : 0,
        LocalDateTime: localDateTime(),
        IsPwdUpdateFromProfile: true,
      })
        .then(async function (response: any) {
          debugger;
          if (response!.data.isResponseSuccessfull) {
            debugger;
            //  reset();
            // setShown(false);
            // setShown1(false);
            // setShown2(false);
            setShowModal(true);
            // setSuccessModal(true);
            // history.push("/confirmation", {
            //   actionType: ActionType.SuccessPasswordReset,
            // });
          } else {
            console.log(
              "Failed response from api is: ",
              response!.data.errorMessage
            );
            console.log("Error: ", errors);
            if (response!.data.errorMessage === "Incorrect password") {
              setError("currentPassword", {
                type: "server",
                message: response!.data.errorMessage,
              });
            } else {
              setError("newPassword", {
                type: "server",
                message: response!.data.errorMessage,
              });
              setError("password", {
                type: "server",
                message: "",
              });
            }
          }
        })
        .catch((error) => {
          // history.push("/confirmation", {
          //   actionType: ActionType.FailureAPIResponse,
          // });
          console.error("Exception caught from API: ", error);
        });
    } catch (error) {
      // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
      // history.push("/confirmation", {
      //   actionType: ActionType.FailureAPIResponse,
      // });
      console.error("Exception caught from API: ", error);
    }
  };

  async function checkDisableTextValidityBtn1(event: any) {
    if (event.target.value !== "" && event.target.value.trim().length !== 0) {
      setIsDisabledBtn1(false);
    } else {
      setIsDisabledBtn1(true);
    }
  }
  async function checkDisableTextValidityBtn2(event: any) {
    if (event.target.value !== "" && event.target.value.trim().length !== 0) {
      setIsDisabledBtn2(false);
    } else {
      setIsDisabledBtn2(true);
    }
  }

  // const dismissSuccessModal = async (boolean: boolean) => {
  //   await modal.current?.dismiss();
  //   setSuccessModal(false);
  // };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => {
          //console.log(data);
          if (data.password === data.newPassword) {
            updateUserPassword(data.password, data.currentPassword);
          }
        })}
        //onSubmit={handleSubmit(UpdatePasssword)}
        autoComplete="off"
      >
        <div className="all-generic-new-modal-center">
          <div className="new-reset-modal-wrap">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cross-icon"
              onClick={() => {
                setShowModal(false);
              }}
            >
              <path
                d="M15.9999 15.9999L3 3"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 3L3 16"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <h4>Change Password</h4>

            {/* Current Password */}
            <div
              className={`field-wrap ${errors.currentPassword && "error-wrap"}`}
            >
              <IonLabel className="label" placeholder={undefined}>
                Current Password{" "}
              </IonLabel>
              <IonInput
                className="input-field"
                type={shownCurrentPassword ? "text" : "password"}
                placeholder="Current Password"
                {...register("currentPassword", {
                  required: true,
                })}
              ></IonInput>

              <div
                className="eye-icon"
                onClick={() => showHidePassword("currentPassword")}
              >
                {shownCurrentPassword ? (
                  <svg
                    className="eye-ist-icon"
                    width="22"
                    height="14"
                    viewBox="0 0 22 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    className="eye-sec-icon"
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 2.77517C10.6327 2.77517 12.3636 4.48649 12.3636 6.59509C12.3636 6.98472 12.2864 7.35907 12.1782 7.71051L14.5427 10.0483C15.6168 9.10859 16.4668 7.93206 17 6.58745C15.6632 3.2412 12.3636 0.865211 8.5 0.865211C7.51864 0.865211 6.57591 1.01801 5.68727 1.30068L7.36409 2.95853C7.72727 2.85157 8.10591 2.77517 8.5 2.77517ZM1.32136 0.223465C1.02 0.521419 1.02 1.00273 1.32136 1.30068L2.84364 2.80573C1.59182 3.79127 0.595 5.09004 0 6.59509C1.33682 9.94898 4.63636 12.325 8.5 12.325C9.67455 12.325 10.795 12.0958 11.8305 11.6985L13.9323 13.7765C14.2336 14.0745 14.7205 14.0745 15.0218 13.7765C15.3232 13.4786 15.3232 12.9973 15.0218 12.6993L2.41864 0.223465C2.11727 -0.0744884 1.62273 -0.0744884 1.32136 0.223465ZM8.5 10.415C6.36727 10.415 4.63636 8.70368 4.63636 6.59509C4.63636 6.00682 4.77545 5.44911 5.015 4.96016L6.22818 6.15962C6.205 6.29714 6.18182 6.44229 6.18182 6.59509C6.18182 7.8633 7.21727 8.88704 8.5 8.88704C8.65454 8.88704 8.79364 8.86412 8.94045 8.83356L10.1536 10.033C9.65136 10.2775 9.095 10.415 8.5 10.415ZM10.795 6.34297C10.6791 5.2734 9.82909 4.44065 8.755 4.32606L10.795 6.34297Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                )}
              </div>

              <div className="field-wrap error-field error-wrap">
                {errors.currentPassword &&
                  errors.currentPassword.type !== "required" &&
                  errors.currentPassword.type === "server" &&
                  errors.currentPassword.message && (
                    <p className="error-msg">
                      {errors.currentPassword.message}
                    </p>
                  )}
              </div>
            </div>
            {/* Current Password */}

            {/* New Password */}
            <div className={`field-wrap ${errors.newPassword && "error-wrap"}`}>
              <IonLabel className="label" placeholder={undefined}>
                New Password{" "}
              </IonLabel>
              <IonInput
                className="input-field"
                type={shownNewPassword ? "text" : "password"}
                placeholder="New Password"
                {...register("password", {
                  required: true,
                  minLength: 8,
                  validate: (value) => value === getValues("newPassword"),
                  pattern: {
                    value:
                      /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*_]{7,}$/,
                    message: "",
                  },
                })}
                onIonChange={(e) => {
                  checkDisableTextValidityBtn1(e);
                }}
              ></IonInput>

              <div
                className="eye-icon"
                onClick={() => showHidePassword("newPassword")}
              >
                {shownNewPassword ? (
                  <svg
                    className="eye-ist-icon"
                    width="22"
                    height="14"
                    viewBox="0 0 22 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    className="eye-sec-icon"
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 2.77517C10.6327 2.77517 12.3636 4.48649 12.3636 6.59509C12.3636 6.98472 12.2864 7.35907 12.1782 7.71051L14.5427 10.0483C15.6168 9.10859 16.4668 7.93206 17 6.58745C15.6632 3.2412 12.3636 0.865211 8.5 0.865211C7.51864 0.865211 6.57591 1.01801 5.68727 1.30068L7.36409 2.95853C7.72727 2.85157 8.10591 2.77517 8.5 2.77517ZM1.32136 0.223465C1.02 0.521419 1.02 1.00273 1.32136 1.30068L2.84364 2.80573C1.59182 3.79127 0.595 5.09004 0 6.59509C1.33682 9.94898 4.63636 12.325 8.5 12.325C9.67455 12.325 10.795 12.0958 11.8305 11.6985L13.9323 13.7765C14.2336 14.0745 14.7205 14.0745 15.0218 13.7765C15.3232 13.4786 15.3232 12.9973 15.0218 12.6993L2.41864 0.223465C2.11727 -0.0744884 1.62273 -0.0744884 1.32136 0.223465ZM8.5 10.415C6.36727 10.415 4.63636 8.70368 4.63636 6.59509C4.63636 6.00682 4.77545 5.44911 5.015 4.96016L6.22818 6.15962C6.205 6.29714 6.18182 6.44229 6.18182 6.59509C6.18182 7.8633 7.21727 8.88704 8.5 8.88704C8.65454 8.88704 8.79364 8.86412 8.94045 8.83356L10.1536 10.033C9.65136 10.2775 9.095 10.415 8.5 10.415ZM10.795 6.34297C10.6791 5.2734 9.82909 4.44065 8.755 4.32606L10.795 6.34297Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                )}
              </div>

              <div className="field-wrap error-field error-wrap">
                {errors.password &&
                  errors.password.type !== "required" &&
                  errors.password.type === "server" &&
                  errors.password.message && (
                    <p className="error-msg">{errors.password.message}</p>
                  )}

                {/* Incase of error also shown under new password */}

                {/* {errors.password &&
                (errors.password.type === "minLength" ||
                  errors.password.type === "pattern") && (
                  <p className="error-msg">
                    Password does not meet the Requirement
                  </p>
                )} */}

                {/* Incase of error also shown under new password */}
              </div>
            </div>
            {/* New Password */}

            {/* Retype New Password */}
            <div className={`field-wrap ${errors.newPassword && "error-wrap"}`}>
              <IonLabel className="label" placeholder={undefined}>
                Retype New Password{" "}
              </IonLabel>
              <IonInput
                className="input-field"
                type={shownConfirmPassword ? "text" : "password"}
                placeholder="New Password"
                {...register("newPassword", {
                  required: true,
                  minLength: 8,
                  validate: (value) => value === getValues("password"),
                  pattern: {
                    value:
                      /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*_]{7,}$/,
                    message: "",
                  },
                })}
                onIonChange={(e) => {
                  checkDisableTextValidityBtn2(e);
                }}
              ></IonInput>

              <div
                className="eye-icon"
                onClick={() => showHidePassword("confirmPassword")}
              >
                {shownConfirmPassword ? (
                  <svg
                    className="eye-ist-icon"
                    width="22"
                    height="14"
                    viewBox="0 0 22 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                      stroke="#D1D1D1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    className="eye-sec-icon"
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 2.77517C10.6327 2.77517 12.3636 4.48649 12.3636 6.59509C12.3636 6.98472 12.2864 7.35907 12.1782 7.71051L14.5427 10.0483C15.6168 9.10859 16.4668 7.93206 17 6.58745C15.6632 3.2412 12.3636 0.865211 8.5 0.865211C7.51864 0.865211 6.57591 1.01801 5.68727 1.30068L7.36409 2.95853C7.72727 2.85157 8.10591 2.77517 8.5 2.77517ZM1.32136 0.223465C1.02 0.521419 1.02 1.00273 1.32136 1.30068L2.84364 2.80573C1.59182 3.79127 0.595 5.09004 0 6.59509C1.33682 9.94898 4.63636 12.325 8.5 12.325C9.67455 12.325 10.795 12.0958 11.8305 11.6985L13.9323 13.7765C14.2336 14.0745 14.7205 14.0745 15.0218 13.7765C15.3232 13.4786 15.3232 12.9973 15.0218 12.6993L2.41864 0.223465C2.11727 -0.0744884 1.62273 -0.0744884 1.32136 0.223465ZM8.5 10.415C6.36727 10.415 4.63636 8.70368 4.63636 6.59509C4.63636 6.00682 4.77545 5.44911 5.015 4.96016L6.22818 6.15962C6.205 6.29714 6.18182 6.44229 6.18182 6.59509C6.18182 7.8633 7.21727 8.88704 8.5 8.88704C8.65454 8.88704 8.79364 8.86412 8.94045 8.83356L10.1536 10.033C9.65136 10.2775 9.095 10.415 8.5 10.415ZM10.795 6.34297C10.6791 5.2734 9.82909 4.44065 8.755 4.32606L10.795 6.34297Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                )}
              </div>

              <div className="field-wrap error-field error-wrap">
                {errors?.newPassword?.type === "validate" && (
                  <p className="error-msg">Password do not match</p>
                )}
                {errors.newPassword &&
                  (errors.newPassword.type === "minLength" ||
                    errors.newPassword.type === "pattern") && (
                    <p className="error-msg">
                      Password does not meet the Requirement
                    </p>
                  )}
                {errors.newPassword && errors?.newPassword.message && (
                  <p className="error-msg">{errors?.newPassword.message}</p>
                )}
              </div>
            </div>
            {/* Retype New Password */}

            {/* Buttons */}
            <div className="btn-wrap-sec two-btns extra-btn-space-wrap">
              <IonButton
                className="generic-btn generic-btn-outline"
                onClick={() => {
                  setShowModal(false);
                }}
                placeholder={undefined}
              >
                Cancel
              </IonButton>
              <IonButton
                className="generic-btn"
                type="submit"
                disabled={isDisabledBtn1 || isDisabledBtn2}
                placeholder={undefined}
              >
                Save
              </IonButton>
            </div>
            {/* Buttons */}
          </div>
        </div>
      </form>
    </>
  );
};

export default ResetPasswordModal;
